import { log } from 'log';
import { useCallback } from 'react';
import { htcmdService } from 'js/services/htcmd.service';

import * as constants from '../../../constants';

export const useRequestNativePacket = ({
    license,
    transactionID,
    userId,
    identifierType,
    reasonRef
}) => {
    return useCallback(() => {
        log('gcReq', { transactionID, license });

        htcmdService.sendMessage('geofencingrequest', {
            provider: 'geocomply',
            license,
            transactionID,
            userId,
            identifierType,
            reason: reasonRef.current ?? constants.GEOLOCATION_REASON.UNDEFINED
        });
    }, [
        license,
        transactionID,
        userId,
        identifierType,
        reasonRef
    ]);
};
